import moment from "moment";
import string from "../../utils/string";
import { applyCurrencyMask } from "../../utils/CurrencyMask";

export const notificationDefault = {
  isOpen: false,
  message: "",
  variant: "",
};

export const tiposFiltro = [{
  label: "Data de emissão",
  value: "EMISSAO",
}, {
  label: "Data de faturamento",
  value: "FATURAMENTO",
}]

export const filtersDefault = {
  statusOrcamentoOdontologico: null,
  numero: "",
  sujeitoAtencao: null,
  dataHoraLancamentoInicio: moment().startOf('month').toDate(),
  dataHoraLancamentoFim: moment().endOf('month').toDate(),
  dataAgendamentoInicio: null,
  dataAgendamentoFim: null,
  tipo: null,
  profissionalSolicitante: null,
  status: { value: "PENDENTE", label: "Pendente" },
  orcamentista: null,
  faturado: null,
  profissionalExecutante: null,
  tipoFiltro: tiposFiltro[0]
};

export const columns = [
  {
    Header: "Número",
    align: "start",
    getValue: (data) => {
      return data.numero;
    },
  },
  {
    Header: "Tipo",
    align: "start",
    getValue: (data) => {
      return string.capitalize(data.tipo);
    },
  },
  {
    Header: "Paciente",
    align: "start",
    getValue: (data) => {
      return data.sujeitoAtencao?.nome || "";
    },
  },
  {
    Header: "Data agendamento",
    align: "start",
    getValue: (data) => {
      return data.agendamento?.id
        ? moment(data.agendamento?.data).format("DD/MM/YYYY")
        : "";
    },
  },
  {
    Header: "Data lançamento",
    align: "start",
    getValue: (data) => {
      return moment(data.dataHoraLancamento).format("DD/MM/YYYY HH:mm");
    },
  },
  {
    Header: "Orçamentista",
    align: "start",
    getValue: (data) => {
      return data.orcamentista?.nome || "";
    },
  },
  {
    Header: "Status",
    align: "start",
    getValue: (data) => {
      const statusOdontologico = data.statusOrcamentoOdontologico?.nome || "";

      return data.tipo === "ODONTOLOGICO" ? statusOdontologico : string.capitalize(data.status);
    },
  },
  {
    Header: "Valor",
    align: "start",
    getValue: (data) => {
      return applyCurrencyMask(data?.valorTotalLiquido || 0);
    },
  },
  {
    Header: "Último registro do histórico",
    align: "start",
    getValue: (data) => {
      const ultimoRegistro = data?.historico?.length > 0 && data?.historico[0];

      return ultimoRegistro ? ultimoRegistro.informacao : "";
    },
  },
  {
    Header: "Solicitante",
    align: "start",
    getValue: (data) => {
      return data.profissionalSolicitante?.nome || "";
    },
  },
  {
    Header: "Convênio",
    align: "start",
    getValue: (data) => {
      return data.convenio?.descricao || "";
    },
  },
  {
    Header: "Faturado",
    align: "start",
    getValue: (data) => {
      return data.faturado ? "Sim" : "Não";
    },
  },
];
